/**
 * Функция возвращает дату начала текущего месяца и текущую дату этого месяца.
 * 
 * @returns {[Date,Date]} [начало месяца, текущая тада месяца]
 */

export function getMonthDates(): [Date, Date] {
  const currentDate = new Date();
  const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  return [startOfMonth, currentDate];
}